import { createSelector } from 'reselect';
import getIn from 'transmute/getIn';
import { getThreadListMembersMap } from '../../thread-list-member/selectors/getThreadListMembersMap';
export const getThreadListMemberWithFirstSLAIndicator = createSelector(getThreadListMembersMap, currentThreadListMembers => currentThreadListMembers.find(getIn(['goalDetails', 'activeGoalType'])));